import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { inject as service } from '@ember/service';

import type SessionUserService from 'volta/services/session-user';

export interface IamSupplierSignature {
  Args: {
    Positional: [];
  };
  Return: boolean;
}

export default class IamSupplierUserHelper extends Helper<IamSupplierSignature> {
  @service sessionUser!: SessionUserService;

  // eslint-disable-next-line ember/no-observers
  onPermissionsInit = observer('sessionUser.user', () => {
    this.recompute();
  });

  compute() {
    return Boolean(this.sessionUser.user?.isSupplier);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'iam-supplier': typeof IamSupplierUserHelper;
  }
}
